<template>
  <div
    class="page-header header-filter"
    :class="{'cursor-wait': isCreatingCourse}"
    filter-color="black"
  >
    <div
      class="page-header-image"
      style="background-image: url(static/img/background/gillwell-background.jpg)"
    />
    <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
    <div class="content">
      <div class="container">
        <div class="row">
          <div
            class="col-lg-8 col-md-8 ml-auto mr-auto"
            style="text-align:left"
          >
            <wizard
              @complete="wizardComplete"
              finish-button-text="Create Course"
              @tab-change="onTabChange"
              :disable-buttons="isCreatingCourse"
              :class="{'cursor-wait': isCreatingCourse}"
            >
              <template slot="header">
                <h3 class="card-title">
                  Create a new Wood Badge Course
                </h3>
                <h3 class="description">
                  This information will help set up the course template.
                </h3>
              </template>
              <wizard-tab :before-change="() => validateStep('step1')">
                <template slot="label">
                  <i class="nc-icon nc-album-2" />
                  Course
                </template>
                <course-info
                  ref="step1"
                  @on-validated="onStepValidated"
                />
              </wizard-tab>
              <wizard-tab :before-change="() => validateStep('step2')">
                <template slot="label">
                  <i class="nc-icon nc-calendar-60" />
                  Sessions
                </template>
                <session-info
                  ref="step2"
                  @on-validated="onStepValidated"
                />
              </wizard-tab>
              <wizard-tab
                :before-change="() => validateStep('step3')"
                v-if="!$root.isLoggedIn"
              >
                <template slot="label">
                  <i class="nc-icon nc-single-02" />
                  User
                </template>
                <user-info
                  ref="step3"
                  @on-validated="onStepValidated"
                />
              </wizard-tab>
              <wizard-tab :before-change="() => validateStep('step4')">
                <template slot="label">
                  <i class="nc-icon nc-single-02" />
                  Scouter
                </template>
                <scouter-info
                  ref="step4"
                  @on-validated="onStepValidated"
                />
              </wizard-tab>
              <wizard-tab :before-change="() => validateStep('step5')">
                <template slot="label">
                  <i class="nc-icon nc-check-2" />
                  Validate
                </template>
                <summary-screen
                  ref="step5"
                  :course-setup-info="wizardModel.courseSetupInfo"
                  :user-setup-info="wizardModel.userSetupInfo"
                />
              </wizard-tab>
            </wizard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import courseInfo from './course-info.vue'
import sessionInfo from './session-info.vue'
import userInfo from './user-info.vue'
import scouterInfo from './scouter-info.vue'
import summaryScreen from './summary-info.vue'
import wizard from '@/plugins/paper-components/wizard/simple-wizard.vue'
import wizardTab from '@/plugins/paper-components/wizard/wizard-tab.vue'
import courseApi from '@/services/api/course'
import security from '@/services/security.js'

export default {
  name: 'CourseCreationWizard',
  components: {
    courseInfo,
    sessionInfo,
    userInfo,
    scouterInfo,
    summaryScreen,
    wizard,
    wizardTab
  },
  data () {
    return {
      isCreatingCourse: false,
      wizardModel: {
        courseSetupInfo: {
          CourseName: null,
          HostingCouncil: null,
          HostingCouncilName: null,
          CurriculumYear: 2020,
          DeliveryStyle: null,
          StaffPrice: null,
          ParticipantPrice: null,
          ParticipatingCouncils: null,
          Session1StartDate: null,
          Session2StartDate: null,
          Location1Name: null,
          Location2Name: null,
          ImportFromTemplate: true
        },
        userSetupInfo: {
          UserName: null,
          Password: null,
          StaffPositionId: null,
          FirstName: null,
          LastName: null,
          ScouterKey: null
        }
      },
      temp1: null,
      temp2: null
    }
  },
  methods: {
    validateStep: function (ref) {
      return this.$refs[ref].validate()
    },
    onStepValidated: function (validated, modelName, model) {
      // this.wizardModel = { ...this.wizardModel, ...model }
      if (modelName) {
        for (const [key, value] of Object.entries(model)) {
          this.wizardModel[modelName][key] = value
        }
      }
    },
    onTabChange: function (oldTab, newTab) {
      this.$refs.step5.refresh()
    },
    wizardComplete: function () {
      if (this.$root.isLoggedIn) {
        this.wizardModel.userSetupInfo.ScouterKey = this.$root.scouterKey
        this.wizardModel.userSetupInfo.FirstName = this.$root.userFirstName
        this.wizardModel.userSetupInfo.LastName = this.$root.userLastName
      }

      this.isCreatingCourse = true

      this.$nextTick(function () {
        courseApi.new(this.wizardModel.courseSetupInfo, this.wizardModel.userSetupInfo)
          .then(response => {
            if (response.ResultCode === 'Success') {
              if (this.$root.isLoggedIn) {
                this.$root.courses.push(response.Courses[0])
                security.setupCourse(this.$root, response.Courses[0].CourseKey)
                this.$emit('wizard-complete')
              } else {
                const nextPage = security.setupVueSession(this.$root, response)
                this.$router.push(nextPage)
              }
            } else {
              this.$notify({
                message: response.ResultCode + ': ' + response.ResultMessage,
                icon: 'ti-icon ti-alert',
                type: 'danger',
                horizontalAlign: 'center',
                timeout: 2000
              })
            }
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: error,
              icon: 'ti-icon ti-alert',
              type: 'danger',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .finally(() => {
            this.isCreatingCourse = false
          })
      })
    }
  }
}
</script>
<style scoped>
@media (max-width:680px) {
  .full-page > .content {
    padding-top: 12vh;
  }
}
.content {
    margin-top: 12%;
  }
  .page-header {
    overflow: hidden;
  }
  .header-filter .container {
    position: relative;
  }
.cursor-wait {
    cursor: wait !important;
  }
</style>
